import React from 'react';
import { TwitchIcon, YouTubeIcon, ViewersIcon, RefreshIcon, GridIcon } from './Icons';
import { loginWithTwitch, loginWithYouTube } from '../api';

export const Landing: React.FC = () => {
  return (
    <div className="landing">
      <div className="landing-content">
        <h1>Stream Tracker</h1>
        <p>
          Your unified streaming dashboard. Track live streams from Twitch and YouTube 
          in one beautiful interface. Never miss when your favorite creators go live.
        </p>
        <div className="login-buttons">
          <button className="btn btn-twitch" onClick={loginWithTwitch}>
            <TwitchIcon />
            Connect Twitch
          </button>
          <button className="btn btn-youtube" onClick={loginWithYouTube}>
            <YouTubeIcon />
            Connect YouTube
          </button>
        </div>
        
        <div className="features-grid">
          <div className="feature-card">
            <h3>
              <GridIcon />
              Unified View
            </h3>
            <p>See all your followed streams from both platforms in one clean dashboard.</p>
          </div>
          <div className="feature-card">
            <h3>
              <ViewersIcon />
              Live Stats
            </h3>
            <p>Real-time viewer counts and stream duration at a glance.</p>
          </div>
          <div className="feature-card">
            <h3>
              <RefreshIcon />
              Auto Refresh
            </h3>
            <p>Streams update automatically so you never miss when someone goes live.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
